/**
 *  Loading script file
**/

export default {
  name: 'loading',
  mixins: [],
  components: {},
  props: {
    color: {
      type: String,
      default: 'var(--colorPrimary)'
    },
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '80px'
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
  }
}
